import React from 'react';
import styled from 'styled-components';
import { handleClickBannersTelcel } from '../../organisms/utils';
import { getBannerIdFromURL } from './utils';

const Container = styled.div`
  margin: ${props => props.margin ? props.margin : "10px 3% -15px 3%"};
  padding: 0px;
  position: relative;
  z-index: 0;
`;

const MegasTelcel = ({ 
	banners, 
	isAnonimous, 
	maxWidth, 
	margin, 
	handleInputClick, 
	autoPlayDelay,
	handleBannerClick
}) => {

	const swiperRef = React.useRef(null);

	React.useEffect(() => {
		const SwiperEl = swiperRef.current;	
		SwiperEl.swiper.update();
		return(() => SwiperEl.swiper.destroy());
	},[banners]);

	return (
		<>
			<Container maxWidth={maxWidth} margin={margin}>
				<swiper-container 	
					ref={swiperRef}
					speed="500"
					pagination-clickable="true"
					space-between="30"
					autoplay-delay={ autoPlayDelay } 
					autoplay-disable-on-interaction="false"
					slides-per-view="1"
					pagination="true"
					autoplay="true"
					loop="true"
					style={{
						"--swiper-pagination-bottom": "0px",
						"--swiper-pagination-color": "#0071d1",
						"--swiper-pagination-bullet-size": "8px",
						"--swiper-pagination-bullet-inactive-color": "#000",
						"--swiper-pagination-bullet-inactive-opacity": "0.3",
						"--swiper-pagination-bullet-opacity": "1",
						"--swiper-pagination-bullet-horizontal-gap": "6px",
					}}
				>
					{
						banners.sections
							?
							banners.sections.map((section, index) => {
								const totalBanners = banners.sections.length;
								const marginBottom = totalBanners > 1 ? "25px" : "0px";
								const image = section.text;
								const logguedAction = section.sections.find(el => el.code === "loggued");
								const notLogguedAction = section.sections.find(el => el.code === "notLoggued");
								const onclick = {
									"loggued": logguedAction.text,
									"notLoggued": notLogguedAction.text
								}

								return (
									<>
										<swiper-slide
											key={index}
											onClick={(e) => {
												if(typeof handleBannerClick === "function"){
													const bannerIdFromURL = getBannerIdFromURL(image);
													handleBannerClick(e,bannerIdFromURL)
												}
												handleClickBannersTelcel(onclick, isAnonimous, handleInputClick)}}>
											<img src={image} style={{ width: '100%', marginBottom }} />
										</swiper-slide>
									</>
								)
							})
							:
							<></>
					}					
				</swiper-container>
			</Container>				
		</>		
	)
}

export default MegasTelcel